class SimpleEventEmitter {
  constructor () {
    this.listeners = {}
  }

  on (event, listener) {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(listener)
  }

  emit (event, ...args) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(listener => listener(...args))
    }
  }

  removeListener (event, listener) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(l => l !== listener)
    }
  }
}

class Lock {
  constructor () {
    this._locked = false
    this._ee = new SimpleEventEmitter()
  }

  acquire () {
    return new Promise(resolve => {
      // If nobody has the lock, take it and resolve immediately
      if (!this._locked) {
        this._locked = true
        return resolve()
      }

      // Otherwise, wait until somebody releases the lock and try again
      const tryAcquire = () => {
        if (!this._locked) {
          this._locked = true
          this._ee.removeListener('release', tryAcquire)
          return resolve()
        }
      }
      this._ee.on('release', tryAcquire)
    })
  }

  release () {
    // Release the lock immediately
    this._locked = false
    setTimeout(() => this._ee.emit('release'), 0)
  }
}

export default Lock
